import { render, staticRenderFns } from "./UserLicencesCard.vue?vue&type=template&id=b34314b0&scoped=true"
import script from "./UserLicencesCard.vue?vue&type=script&lang=js"
export * from "./UserLicencesCard.vue?vue&type=script&lang=js"
import style0 from "./UserLicencesCard.vue?vue&type=style&index=0&id=b34314b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34314b0",
  null
  
)

export default component.exports